import { render } from "./AffectationCaisseModal.vue?vue&type=template&id=452991eb&ts=true"
import script from "./AffectationCaisseModal.vue?vue&type=script&lang=ts"
export * from "./AffectationCaisseModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__